import { Grid, Paper, Radio } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import { blackColor, checkboxColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import {
  beatNotAssignMsg,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
} from "../../config/messageconstant";

import { WeeklyOffJsonNew } from "../../DynamicFormsJson/MastersJSON/WeeklyOffNew";
import { getSalesExecutiveForWeeklyOff } from "../../Slice/salesExecutive.slice";
import { getWeeklyOffUserWise } from "../../Slice/weeklyOff.slice";
import { apiGet, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";

class WeeklyOffFormNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
      beatAssignList: [],
      salesTeamId: "",
      adminFlag: false,
      dynamicMasterData: {
        salesExecutiveDetail: this.props.salesExecutive.salesExecutive,
      },
      matrixData: [],
      dayList: [
        {
          dayId: 0,
          name: "Mon",
        },
        {
          dayId: 1,
          name: "Tue",
        },
        {
          dayId: 2,
          name: "Wed",
        },
        {
          dayId: 3,
          name: "Thu",
        },
        {
          dayId: 4,
          name: "Fri",
        },
        {
          dayId: 5,
          name: "Sat",
        },
        {
          dayId: 6,
          name: "Sun",
        },
      ],
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.salesExecutive !== nextProps.salesExecutive) {
      if (
        this.props.salesExecutive?.salesExecutive !==
        nextProps.salesExecutive?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesExecutiveDetail: nextProps.salesExecutive?.salesExecutive,
          },
        });
      }
    }
  }

  async componentDidMount() {
    const { getSalesExecutiveForWeeklyOff, showLoador, showNotification } =
      this.props;

    if (navigator.onLine) {
      showLoador({ loador: true });
      await getSalesExecutiveForWeeklyOff().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
    if (this.props.params.id) {
      this.getDataById(this.props.params.id);
    }
  }

  getListById = async (data) => {
    const { getSalesExecutiveForWeeklyOff, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getSalesExecutiveForWeeklyOff().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearch = (data) => {
    const { getWeeklyOffUserWise, showLoador, showNotification } = this.props;
    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return;
    }

    const salesTeamIds =
      typeof data.salesTeam === "string"
        ? data.salesTeam.split(",").map((id) => id.trim())
        : [data.salesTeam.id];

    this.setState({
      matrixData: [],
      salesTeamId: salesTeamIds,
    });

    showLoador({ loador: true });
    getWeeklyOffUserWise({
      dataJson: { salesTeamIds },
    }).then(({ response, success }) => {
      showLoador({ loador: false });

      if (!success) {
        showNotification({ msg: serverMsg, severity: "error" });
        return;
      }

      if (!Array.isArray(response) || response.length === 0) {
        showNotification({ msg: "No data found", severity: "error" });
        return;
      }

      const matrixData = response.map((user) => {
        const selectedDays = Array.isArray(user.days)
          ? user.days.map((d) => this.state.dayList[d].name)
          : [];
        return {
          id: user.id,
          userId: user.userId,
          name: user.name,
          designation: user.designation || "-",
          selectedDays,
        };
      });

      this.setState({ matrixData });
    });
  };

  onSubmit = () => {
    const { matrixData, salesTeamId } = this.state;
    const { showLoador, showNotification } = this.props;

    const saveList = [];

    matrixData.map((row) => {
      if (Array.isArray(row.selectedDays) && row.selectedDays.length > 0) {
        row.selectedDays.map((dayName) => {
          const dayObj = this.state.dayList.find((d) => d.name === dayName);
          if (dayObj) {
            saveList.push({
              salesTeamId: row.userId || row.id || salesTeamId[0],
              day: dayObj.dayId,
            });
          }
        });
      }
    });

    if (saveList.length === 0) {
      showNotification({
        msg: "Please select at least one day.",
        severity: "error",
      });
      return;
    }

    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return;
    }

    swal({
      title: "Are you sure?",
      text: saveWarningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willSave) => {
      if (willSave) {
        showLoador({ loador: true });

        apiPost({
          url: endpoint.weeklyOfUserWise + "/save-list",
          postBody: saveList,
        }).then(({ success }) => {
          showLoador({ loador: false });

          if (success) {
            showNotification({ msg: savemsg });
            this.setState({ matrixData: [] });
            window.location.replace("/weekly-off-table");
          } else {
            showNotification({ msg: saveFailedMsg, severity: "error" });
          }
        });
      }
    });
  };

  getDataById = (data) => {
    const { showLoador } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      const response = apiGet({
        url:
          endpoint.weeklyOfUserWise +
          "/by-sales-team?salesTeamId=" +
          this.props.params.id,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (!data.error) {
            let rowData = data.data;
            this.setState({
              DataToSet: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Sales Team",
                  value: data?.salesTeamName || rowData?.salesTeamName || "-",
                },
              ],
            });
            this.onSearch({ salesTeam: { id: this.props.params.id } });
            return { data: rowData, success };
          }
          return { data: {}, success: false };
        }

        return { data: {}, success: false };
      });
      return response;
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  render() {
    const { matrixData, dynamicMasterData, DataToSet, dayList, adminFlag } =
      this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showSaveBtn={WeeklyOffJsonNew.showSaveBtn}
            showTitle={WeeklyOffJsonNew.showTitle}
            screenTitle={WeeklyOffJsonNew.screenTitle}
            fieldMeta={
              this.props.params.id
                ? WeeklyOffJsonNew.fieldMetaNew
                : WeeklyOffJsonNew.fieldMeta
            }
            showCancel={WeeklyOffJsonNew.showCancel}
            apiBaseURL={WeeklyOffJsonNew.apiBaseURL}
            showSaveNextBtn={WeeklyOffJsonNew.showSaveNextBtn}
            saveBtnText={"Search"}
            showSaveBtnMain={this.props.params.id ? false : true}
            getListById={this.getListById}
            onSave={this.onSearch}
          />
          {matrixData.length != 0 && (
            <>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={{ width: "5%" }}>
                        SR No
                      </TableCell>
                      <TableCell align="center" sx={{ width: "20%" }}>
                        Sales Team Name
                      </TableCell>
                      <TableCell align="center" sx={{ width: "20%" }}>
                        Designation
                      </TableCell>
                      <TableCell align="center" sx={{ width: "55%" }}>
                        Days
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {matrixData.map((matrixDataRow, indexRow) => (
                      <TableRow key={indexRow}>
                        <TableCell align="center">{indexRow + 1}</TableCell>

                        <TableCell align="left">
                          {matrixDataRow?.name || "-"}
                        </TableCell>

                        <TableCell align="left">
                          {matrixDataRow?.designation || "-"}
                        </TableCell>

                        <TableCell align="center">
                          <FormControl component="fieldset">
                            <FormGroup row>
                              {this.state.dayList.map((dayObj) => (
                                <FormControlLabel
                                  key={dayObj.dayId}
                                  control={
                                    <Radio
                                      sx={{
                                        color: blackColor,
                                        "&.Mui-checked": {
                                          color: checkboxColor,
                                        },
                                      }}
                                      checked={
                                        matrixDataRow.selectedDays?.includes(
                                          dayObj.name
                                        ) || false
                                      }
                                      onClick={() => {
                                        this.setState((prevState) => {
                                          const updatedMatrix =
                                            prevState.matrixData.map(
                                              (m, idx) => {
                                                if (idx === indexRow) {
                                                  const selectedDays =
                                                    m.selectedDays || [];
                                                  const isSelected =
                                                    selectedDays.includes(
                                                      dayObj.name
                                                    );
                                                  const newSelected = isSelected
                                                    ? selectedDays.filter(
                                                        (d) => d !== dayObj.name
                                                      ) // deselect
                                                    : [
                                                        ...selectedDays,
                                                        dayObj.name,
                                                      ]; // select

                                                  return {
                                                    ...m,
                                                    selectedDays: newSelected,
                                                  };
                                                }
                                                return m;
                                              }
                                            );
                                          return { matrixData: updatedMatrix };
                                        });
                                      }}
                                    />
                                  }
                                  label={dayObj.name.slice(0, 3)}
                                  labelPlacement="end"
                                />
                              ))}
                            </FormGroup>
                          </FormControl>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                rowSpacing={2}
                columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                container
                justifyContent="right"
                sx={{ mt: 2 }}
              >
                <ButtonCompo
                  size="medium"
                  type="submit"
                  variant="contained"
                  name="Submit"
                  onClick={this.onSubmit}
                />
              </Grid>
            </>
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesExecutive: state.salesExecutive,
  weeklyOffList: state.weeklyOff,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getSalesExecutiveForWeeklyOff,
  getWeeklyOffUserWise,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(WeeklyOffFormNew);
